import * as React from 'react';
import { UserViewModel } from 'stageclip-common';

import * as UserHelper from '../../helpers/userHelper';

interface FullNameOwnProps {
  user: UserViewModel;
}

export class FullName extends React.Component<FullNameOwnProps> {
  public render() {
    // eslint-disable-next-line react/destructuring-assignment
    return UserHelper.userFullName(this.props.user);
  }
}
